export default __webpack_public_path__ + "static/media/email.514fc63b.svg";